const message = {
  state: {
    unreadCount: 0
  },
  mutations: {
    updateMessageUnreadCount (state, unreadCount) {
      state.unreadCount = unreadCount
    },
    cleanMessageUnreadCount (state) {
      state.unreadCount = 0
    },
    increaseMessageUnreadCount (state) {
      state.unreadCount++
    },
    decreaseMessageUnreadCount (state) {
      if (state.unreadCount > 0) {
        state.unreadCount--
      }
    }
  }
}

export default message
